import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { tsIoValidate } from "../../../../utils/general/generalUtils"
import { getClientProtected } from "../../clients/clients"
import {
    GetOrgRes,
    TGetOrgRes,
} from "../../types/organisation/organisationTypes"
import { GET_MY_ORG } from "../../urls/private"

interface IUseGetMyOrg {
    data: TGetOrgRes | undefined
    isLoading: boolean
    isValidating: boolean
    error: undefined | AppError
}

/**
 * Gets details on a users org
 * @returns {IUseGetMyOrg} - loading and error states.
 */
const useGetMyOrg = (): IUseGetMyOrg => {
    const { data, error, isLoading, isValidating } = useSWR(
        GET_MY_ORG,
        async (url: string): Promise<TGetOrgRes> => {
            try {
                const res = await getClientProtected(url)
                return tsIoValidate<TGetOrgRes>(
                    GetOrgRes,
                    res,
                    "Invalid organisation received from server"
                )
            } catch (err) {
                throw parseAndThrowAppError(err)
            }
        }
    )

    return {
        data,
        isLoading,
        error,
        isValidating,
    }
}

export default useGetMyOrg
